import React from 'react'
import classnames from 'classnames/bind'
import { useTranslation } from 'next-i18next'
import useI18n from '@/hooks/useI18n'

// Methods
import { getCompanyBrandName, getCompanyNameDefault } from '@/components/pages/Terms/methods/company'

// Styles
import styles from './style.module.scss'

// Variable
const cx = classnames.bind(styles)

const UserTerms = () => {
  const { t } = useTranslation()
  const { isOverseaUser } = useI18n()

  return (
    <div className={cx('user-terms__container')}>
      <div className={cx('user-terms')}>
        <div className={cx('user-terms__title')}>{t('UserTerms_Title', { brandName: getCompanyBrandName(isOverseaUser) })}</div>
        <div className={cx('user-terms__desc')}>{t('UserTerms_Description', { brandName: getCompanyBrandName(isOverseaUser) })}</div>
        <div className={cx('user-terms__toc')}>
          <div>{t('UserTerms_Menu')}</div>
        </div>
        <div className={cx('user-terms__section')}>
          <div className={cx('user-terms__section-title')}>{t('UserTerms_Menu_1')}</div>
          <div className={cx('user-terms__section-list')}>
            <div>{t('UserTerms_Description_1')}</div>
          </div>
        </div>

        <div className={cx('user-terms__section')}>
          <div className={cx('user-terms__section-title')}>{t('UserTerms_Menu_2')}</div>
          <div className={cx('user-terms__section-list')}>
            <div>{t('UserTerms_Description_2')}</div>
          </div>
        </div>

        <div className={cx('user-terms__section')}>
          <div className={cx('user-terms__section-title')}>{t('UserTerms_Menu_3')}</div>
          <div className={cx('user-terms__section-list')}>
            <div>{t('UserTerms_Description_3')}</div>
          </div>
        </div>

        <div className={cx('user-terms__section')}>
          <div className={cx('user-terms__section-title')}>{t('UserTerms_Menu_4')}</div>
          <div className={cx('user-terms__section-list')}>{t('UserTerms_Description_4')}</div>
        </div>

        <div className={cx('user-terms__section')}>
          <div className={cx('user-terms__section-title')}>{t('UserTerms_Menu_5')}</div>
          <div className={cx('user-terms__section-list')}>
            <div>{t('UserTerms_Description_5')}</div>
          </div>
        </div>

        <div className={cx('user-terms__section')}>
          <div className={cx('user-terms__section-title')}>{t('UserTerms_Menu_6')}</div>
          <div className={cx('user-terms__section-list')}>
            <div>{t('UserTerms_Description_6')}</div>
          </div>
        </div>

        <div className={cx('user-terms__section')}>
          <div className={cx('user-terms__section-title')}>{t('UserTerms_Menu_7')}</div>
          <div className={cx('user-terms__section-list')}>{t('UserTerms_Description_7')}</div>
        </div>

        <div className={cx('user-terms__section')}>
          <div className={cx('user-terms__section-title')}>{t('UserTerms_Menu_8')}</div>
          <div className={cx('user-terms__section-list')}>
            <div>{t('UserTerms_Description_8', { brandName: getCompanyBrandName(isOverseaUser) })}</div>
          </div>
        </div>

        <div>
          <div>
            {t('UserTerms_Company_Name')}
            {getCompanyNameDefault(isOverseaUser, t)}
          </div>
          {isOverseaUser && <div>{t('UserTerms_Company_Address')}UNIT A56, 29/F., LEGEND TOWER, 7 SHING YIP STREET, KWUN TONG KOWLOON HK</div>}
          <>
            {!isOverseaUser ? (
              <>
                <div>{t('UserTerms_Company_Manager')}楊懋慈</div>
                <div>
                  {t('UserTerms_Company_Website')}
                  <a href='https://www.tutorabcshop.com/live' target='_blank' rel='noopener noreferrer'>
                    https://www.tutorabcshop.com/live
                  </a>
                </div>
                <div>{t('UserTerms_Company_Uniform_Number')}94059616</div>
                <div>{t('UserTerms_Company_Address')}新北市板橋區文化路2段293號6樓</div>
                <div>
                  {t('UserTerms_Company_Email')}
                  <a href='mailto:shopservice@tutorabcshop.com'>shopservice@tutorabcshop.com</a>
                </div>
                <div>{t('UserTerms_Company_Line')}@tutorabcshop</div>
              </>
            ) : (
              <></>
            )}
          </>
          <div style={{ marginTop: '12px' }}>{t('UserTerms_Company_Email_24_Hours')}</div>
        </div>
      </div>
    </div>
  )
}

export default UserTerms
